'use client';

import type { CmsApiPagePost } from '#/modules/cms/api/types/CmsApiPage';
import { useReloadIfFreeCodeBlockAndClientNavigation } from '#/modules/cms/hooks/useReloadIfFreeCodeBlockAndClientNavigation';
import { LazyNotFoundPage } from '#/pages/NotFound/LazyNotFoundPage';

import { CmsPostPageBody } from './Body/CmsPostPageBody';
import { CmsPostPageLayout } from './Layout/CmsPostPageLayout';

type Props = {
  content: CmsApiPagePost;
};

export function CmsPostPage({ content }: Props) {
  const { showPageNotFound } =
    useReloadIfFreeCodeBlockAndClientNavigation(content);
  if (showPageNotFound) return <LazyNotFoundPage />;

  return (
    <CmsPostPageLayout content={content}>
      <CmsPostPageBody content={content} />
    </CmsPostPageLayout>
  );
}
